import { render, staticRenderFns } from "./ticketPurchaseInformation.vue?vue&type=template&id=1bc0c6b4"
import script from "./ticketPurchaseInformation.vue?vue&type=script&lang=js"
export * from "./ticketPurchaseInformation.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ticketPurchaseInformation.vue?vue&type=style&index=1&id=1bc0c6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports